
import { LoadingMessage } from 'views/components/loading';
import './styles.scss';
import IconLG from "assets/img/IconLGx32.png";

const LoadingAnswer = (props: { isHidden: boolean, chatbotName: string }) => {
  return (
    <div>
      <div className='other_user' hidden={props.isHidden}>
        <div className='infor'>
          <img
            src={IconLG}
            alt=''
            style={{width: '36px'}}
          />
          <div className='name'>{props.chatbotName}</div>
        </div>
        <LoadingMessage />
      </div>
    </div>
  );
};
export default LoadingAnswer;
